// Cross-tree bridge for page content (e.g. HeroBlock) to override the fixed
// header's theme. Page content and Header are siblings under the root layout
// (see src/app/(app)/layout.tsx), not both descendants of HeaderContextProvider,
// so React context can't carry this — same rationale as src/lib/activeInput.ts.
export type PageTheme = 'dark' | 'light' | null

let current: PageTheme = null
const listeners = new Set<(val: PageTheme) => void>()

export function getPageTheme(): PageTheme {
  return current
}

export function setPageTheme(val: PageTheme) {
  if (current === val) return
  current = val
  listeners.forEach((fn) => fn(current))
}

export function subscribePageTheme(fn: (val: PageTheme) => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
